import { render, staticRenderFns } from "./diagnosis-consultation-modal-consultation-new.vue?vue&type=template&id=06a04219&scoped=true&"
import script from "./diagnosis-consultation-modal-consultation-new.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal-consultation-new.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal-consultation-new.scss?vue&type=style&index=0&id=06a04219&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a04219",
  null
  
)

export default component.exports